module.exports = __webpack_public_path__ + "media/images/about/h_3-8e248f01115b2c4991c806a42c89eeb4.png";